import React, { useState, useEffect, useContext } from 'react';
import { swalMessages } from 'src/constants';
import fontsService from 'src/services/fontsService';
import { ContextDownload } from 'src/context/ContextDownload';
import { Context } from 'src/context/Contex';
import FontsControlPage from 'src/pages/AdminControl/FontsAdmin/AdminControlFontsPage';
import filterArray from 'src/utils/filterArray';
import swal from 'sweetalert';

const AdminFontsContainer = () => {
  const [fonts, setFonts] = useState([]);
  const { permisos } = useContext(Context);
  const { setIdReport } = useContext(ContextDownload); // preguntar
  const [create, setCreate] = useState({});
  const [inputSearch, setInputSearch] = useState('');

  // Obtener fuentes de datastudio
  const getFuentesDataStudio = async () => {
    const response = await fontsService.getFontsDataStudio();
    if (response) {
      setFonts(response);
    } else {
      swal(swalMessages.WARNING_GENERAL);
    }
  };

  useEffect(() => {
    let active = true;
    if (active) {
      getFuentesDataStudio();
    }
    return () => {
      active = false;
    };
  }, []);

  // Crear fuente en datastudio
  const handleSubmit = async (event) => {
    event.preventDefault();
    const response = await fontsService.postFontsDataStudio(create);
    setCreate('');
    if (response.success === 0) {
      swal(swalMessages.WARNING_GENERAL);
    } else {
      swal(swalMessages.SUCCESSFUL_MESSAGE);
      setFonts((prev) => [...prev, { ...create, id: response.id }]);
      setCreate({});
    }
  };

  // Eliminar fuente DataStudio
  const handleDelete = (params) => {
    swal(swalMessages.DELETE_CONFIRM).then(async (willDelete) => {
      if (willDelete) {
        const response = await fontsService.delFontDataStudio(params);
        setCreate('');
        if (response.data.success === 0) {
          swal(swalMessages.WARNING_GENERAL);
        } else {
          getFuentesDataStudio();
          swal('Ok! Fuente eliminada exitosamente', {
            icon: 'success',
          });
        }
      }
    });
  };

  const onCreate = (event, type) => {
    setCreate({ ...create, [type]: event.target.value });
  };

  // actualizar fuente Datastudio
  const handleUpdate = async (params) => {
    const body = Object.assign(
      fonts.find((fonts) => fonts.id === params),
      create,
    );
    const response = await fontsService.editFontDataStudio(body);
    if (response.success === 0) {
      swal(swalMessages.WARNING_GENERAL);
    } else {
      setCreate({});
      swal(swalMessages.SUCCESFUL_UPDATE);
      getFuentesDataStudio();
    }
  };
  const onChangeInput = (event) => {
    setInputSearch(event.target.value.toLowerCase());
  };
  const filteredItems = filterArray(fonts, 'nombre', inputSearch);

  return (
    <>
      <FontsControlPage
        create={create}
        permisos={permisos}
        onCreate={onCreate}
        fonts={filteredItems}
        onDelete={handleDelete}
        setIdReport={setIdReport}
        handleUpdate={handleUpdate}
        handleSubmit={handleSubmit}
        onChangeInput={onChangeInput}
      />
    </>
  );
};

export default AdminFontsContainer;
